var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insta-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.154,
    height: 14.154,
    viewBox: "0 0 14.154 14.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Instagram",
    d: "M507.077,160c-1.922,0-2.163.008-2.918.043a5.193,5.193,0,0,0-1.718.329,3.619,3.619,0,0,0-2.07,2.07,5.2,5.2,0,0,0-.329,1.718c-.034.755-.043,1-.043,2.918s.008,2.163.043,2.918a5.2,5.2,0,0,0,.329,1.718,3.619,3.619,0,0,0,2.07,2.07,5.194,5.194,0,0,0,1.718.329c.755.034,1,.043,2.918.043s2.163-.008,2.918-.043a5.194,5.194,0,0,0,1.718-.329,3.619,3.619,0,0,0,2.07-2.07,5.2,5.2,0,0,0,.329-1.718c.034-.755.043-1,.043-2.918s-.008-2.163-.043-2.918a5.2,5.2,0,0,0-.329-1.718,3.618,3.618,0,0,0-2.07-2.07,5.193,5.193,0,0,0-1.718-.329C509.24,160.008,509,160,507.077,160Zm0,1.275c1.89,0,2.114.007,2.86.041a3.917,3.917,0,0,1,1.314.244,2.344,2.344,0,0,1,1.343,1.343,3.913,3.913,0,0,1,.244,1.314c.034.746.041.97.041,2.86s-.007,2.113-.041,2.86a3.913,3.913,0,0,1-.244,1.314,2.344,2.344,0,0,1-1.343,1.343,3.918,3.918,0,0,1-1.314.244c-.746.034-.97.041-2.86.041s-2.114-.007-2.86-.041a3.918,3.918,0,0,1-1.314-.244,2.343,2.343,0,0,1-1.343-1.343,3.914,3.914,0,0,1-.244-1.314c-.034-.746-.041-.97-.041-2.86s.007-2.114.041-2.86a3.914,3.914,0,0,1,.244-1.314,2.344,2.344,0,0,1,1.343-1.343,3.917,3.917,0,0,1,1.314-.244C504.964,161.282,505.187,161.275,507.077,161.275Zm0,2.168a3.634,3.634,0,1,0,3.634,3.634A3.634,3.634,0,0,0,507.077,163.443Zm0,5.993a2.359,2.359,0,1,1,2.359-2.359A2.359,2.359,0,0,1,507.077,169.436ZM511.7,163.3a.849.849,0,1,1-.849-.849A.849.849,0,0,1,511.7,163.3Z",
    transform: "translate(-500 -160)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta-icon.ddf4c3c126efec4336beb994ec624cce.svg";
export { ForwardRef as ReactComponent };